module.exports = __webpack_public_path__ + "img/device-web.891b6543.svg";